import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { compose } from 'recompose';

import {
  HeaderRow,
  SubTitle,
  Title,
  TitleContainer,
} from '../../../../../../../components/v2/Header';
import { withExternalCoachContextReady } from '../../../../../../context/ExternalCoachContext';
import RoundedButton from '../../../../../../../components/v2/RoundedButton';
import OneTimeContractModal from '../../../../../../components/ContractModal/Modals/OneTimeContractModal';

import texts from './texts.json';

const OneTimeContracts = () => {
  const [showContractModal, setShowContractModal] = useState(false);

  return (
    <>
      <HeaderRow>
        <TitleContainer>
          <Title>{texts.title}</Title>
          <SubTitle>{texts.subTitle}</SubTitle>
        </TitleContainer>

        <RoundedButton onClick={() => setShowContractModal(true)} style={{ minWidth: '250px' }}>
          {texts.createOneTimeContract}
        </RoundedButton>
      </HeaderRow>

      {!!showContractModal && (
        <OneTimeContractModal
          showModal
          onClose={() => setShowContractModal(false)}
        />
      )}
    </>
  );
};

export default compose(
  withExternalCoachContextReady,
  observer,
)(OneTimeContracts);
